import { render, staticRenderFns } from "./SidebarVariant.vue?vue&type=template&id=fa9c3406&"
import script from "./SidebarVariant.vue?vue&type=script&lang=js&"
export * from "./SidebarVariant.vue?vue&type=script&lang=js&"
import style0 from "./SidebarVariant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports